import { useMemo } from 'react'
import camelCase from 'lodash/camelCase'
import { useAdsConfigQuery } from '@mwxltd/flix-api-client'
import { useMediaIs } from '../../../style/media.js'
import { useSkippedListAds } from './ListAdInsertionContext.js'
import { insertListAds } from './insertListAds.js'

export const useListAdInsertion = ({ list, skip }) => {
  const sm = useMediaIs('sm')

  const { data } = useAdsConfigQuery()

  const adsConfig = data?.listAdTemplates
  const adConfig = list && adsConfig?.[camelCase(list.slug)]
  const adTemplate = adConfig?.adTemplate
  const skippedAds = useSkippedListAds(
    adTemplate?.zone,
    (sm ? adTemplate?.placement : adTemplate?.placementMobile) ??
      adTemplate?.placement ??
      adTemplate?.placementMobile,
  )

  return useMemo(
    () => insertListAds({ list, adConfig, skippedAds, skip }),
    [list, adConfig, skippedAds, skip],
  )
}
